import { render } from "./Player.vue?vue&type=template&id=4a6903bb&scoped=true"
import script from "./Player.js?vue&type=script&lang=js"
export * from "./Player.js?vue&type=script&lang=js"

import "./Player.scss?vue&type=style&index=0&id=4a6903bb&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6903bb"]])

export default __exports__